<template>
<div v-show="totalPromotionList.length" >
  <div class="promoContainer">
  <span class="fieldTitle">
    {{ $vuetify.t('$vuetify.menu.promotionsAndRewards') }}
  </span>
</div>
  <v-layout>
    <v-flex row xs12>
      <v-layout row wrap grid-list-md class="menuContainer">
        <div class="carousel-container" 
          :class="{'custom-header-carousel': shouldUseCustomHeader}"
          @touchstart="handleTouch" 
          @touchmove="handleTouch" 
          @touchend="handleTouch"
          @touchcancel="handleTouch"
          @wheel="handleWheel"
        >
        <carousel :perPageCustom="[[0, 1],[768, 2],[1024, 3],[1440, 4]]" :scrollPerPage=false
        :paginationEnabled=false navigationEnabled :adjustableHeight="true"
        class="no-page-scroll"
        >
        <template v-for="(promotion, index) in filteredPromotionList">
            <slide style="padding-left: 10px; padding-right: 10px;" class="rewards-slide">
            <promotion-rewards-card 
                v-if="shouldShowAsPromoCard(promotion)"
                allowConfig 
                :coupon="promotion" 
                max-width="100%" 
                :key="index"
                :disabled="!isFullyEligible(promotion)"
            />
            <div v-if="'rewardNameString' in promotion || 'unitString' in promotion || 'unitPluralString' in promotion" @click="handlePunchCard(promotion)">
              <PunchCard :isFromHome="true" :punchCard="getFullPunchCard(promotion)" :promotion="promotion" />
            <!-- <card-wrapper
              :forced-height="106"
              :forced-width="284"
              :min-width="284"
            >
                <template v-slot:textBody>
                    <div class="header">
                      {{ promotion.name }}
                    </div>
                </template>
            </card-wrapper> -->
          </div>
          <div v-else-if="'referralNameString' in promotion">
             <card-wrapper
              :forced-height="106"
              :forced-width="284"
              :min-width="284"
              :onClick="openDialog"
            >
                <template v-slot:textBody>
                    <div class="header">
                        {{ promotion.rewardName }}
                    </div>
                    <div class="subheader">
                        {{ promotion.referralNameString }}
                    </div>
                    <ReferralCard :referralLink="referralLink" :referral="promotion" :referralSettings="referralSettings" />
                </template>
            </card-wrapper>
          </div>
          <div v-else-if="'redeemPoints' in promotion && !promotion._isCoupon">
            <card-wrapper
              :forced-height="106"
              :forced-width="284"
              :min-width="284"
              :image="getImage(promotion)"
              :onClick="isRewardValid(promotion) ? () => handleRedeemable(promotion) : null"
              :css-class="`RewardsOptionCard promotionrewardscard ${!isRewardValid(promotion) ? 'disabled' : ''}`"
            >
              <template v-slot:textBody>
                <div class="rewards-card-content">
                  <div class="header redemption-title">
                   {{ promotion.rewardName | comma }}
                  </div>
                  <div v-if="promotion.discountRule" class="discount-rule">
                    • {{ getDiscountText(promotion.discountRule) }}
                  </div>
                  <div v-if="hasTargets(promotion)" class="valid-items-rule">
                    • {{ $vuetify.t('$vuetify.account.rewards.validForSelectItems') }}
                  </div>
                  <div class="subheader-container">
                    <div v-if="!isRewardValid(promotion)" class="subheader error-message">
                      {{ getRewardErrorMessage(promotion) }}
                    </div>
                    <div v-else class="subheader redeem-points-normal">
                       {{ $vuetify.t('$vuetify.account.rewards.redeemFor') }} {{ promotion.redeemPoints | comma }} {{ $vuetify.t('$vuetify.account.rewards.points') }}
                    </div>
                    <div class="subheader expiration-text">
                      {{ getExpirationText(promotion) }}
                    </div>
                  </div>
                </div>
                <RewardOptionsCard v-show="false" :rewardOption="promotion" />
              </template>
            </card-wrapper>
          </div>
            </slide>
        </template>
        </carousel>
        </div>
      </v-layout>
    </v-flex>
  </v-layout>
</div>
</template>

<script>
import get from 'lodash/get';
import { matchTranslation } from "@/services/util.service";
import { mapGetters, mapActions, mapMutations } from 'vuex';
import { getCurrencySymbol, formatDiscountCap } from '@/services/currency.service';

import storePage from '@/views/StorePage.vue'
import PunchCard from '@/components/Common/PunchCard'
import RewardOptionsCard from "@/components/RewardsOptions/RewardOptionsCard"
import ReferralCard from '@/components/RewardsOptions/ReferralCard'
import CardWrapper from "@/components/Wrappers/CardWrapper"
import PunchCardDetail from '../Common/PunchCardDetail.vue';


export default {
  extends: storePage,
  components: { PunchCard, PunchCardDetail, RewardOptionsCard, ReferralCard, CardWrapper },
  data() {
    return {}
  },
  computed: {
    referralLink() {
      const groupPageUrl = `${window.location.origin}/owa/g/-/${this.getStore.groupId}`;
      return `${groupPageUrl}?referrer=${this.getCustomer.id}`;
    },
    referralSettings() {
      const store = this.getStore;
      const group = this.getGroup;
      return (store && store.settings && store.settings.rewardsSettings && store.settings.rewardsSettings.referralSettings) ||
             (group && group.settings && group.settings.rewardsSettings && group.settings.rewardsSettings.referralSettings) ||
             {};
    },
    filteredPromotionList() {
      return this.totalPromotionList.filter(promotion => {
        if ('rewardNameString' in promotion || 
            'unitString' in promotion || 
            'unitPluralString' in promotion ||
            'referralNameString' in promotion || 
            'redeemPoints' in promotion) {
          return true;
        }
        
        if (promotion && 'eligibilityResult' in promotion) {
          // DEV-11340: Purchase Coupons is deprecated -- never offer a coupon that's for sale.
          if (!!promotion.charges && !promotion.uuid) return false;
          return !!(promotion.eligibilityResult.isEligible ||
                 promotion.eligibilityResult.shouldShowIfNotEligible);
        }
        
        return false;
      });
    },
    totalPromotionList() {
        return this.rewardsList.concat(this.coupons.map(c => ({ ...c, _isCoupon: true })));
    },
    // Hiding punchcards based on the ticket DEV-4643
    punchCards() {
      return get(this.getRewards, 'punchCards', [])
    },
    redeemOptions() {
      const orderType = this.getOrderType
      return get(this.getRewards, 'redeemOptions', []).filter(item => {
        if (item.freeDelivery && orderType !== 'DELIVERY') return false
        return true
      })
    },
    rewardsList() {
      const store = this.getStore;
      const group = this.getGroup;
      const storeRewardsSettings = store && store.settings && store.settings.rewardsSettings;
      const groupRewardsSettings = group && group.settings && group.settings.rewardsSettings;

      const supportsReferralBonus =
        (storeRewardsSettings && storeRewardsSettings.supportsReferralBonus) ||
        (groupRewardsSettings && groupRewardsSettings.supportsReferralBonus);

      if (supportsReferralBonus) {
        const referralSettings =
          (storeRewardsSettings && storeRewardsSettings.referralSettings) ||
          (groupRewardsSettings && groupRewardsSettings.referralSettings) ||
          {};

        const title = referralSettings.title && referralSettings.title.translations
          ? matchTranslation(referralSettings.title.translations)
          : null;

        const description = referralSettings.description && referralSettings.description.translations
          ? matchTranslation(referralSettings.description.translations)
          : null;

        const referral = {
            id: "referral",
            isItem: false,
            onlineRedeemable: true,
            rewardName: title || "Earn Rewards By Referring Friends",
            referralNameString: description || "Invite your friends to enjoy our delicious meals, and you'll both earn 100 points! Share the love and start earning rewards today"
        };

        return [
          referral,
          ...(this.punchCards || []),
          ...(this.redeemOptions || [])
        ].filter(Boolean);
      }

      return [
        ...(this.punchCards || []),
        ...(this.redeemOptions || [])
      ].filter(Boolean);
    },
    perPage() {
     return [[0,1],[1024, 4]]
    },
    coupons() {
      const orderType = this.getOrderType
      return get(this.getCustomerRewards, 'coupons', []).filter(item => {
        if (!this.passSearch(item)) return false
        if (item.freeDelivery && orderType !== 'DELIVERY') return false
        if (item.validOrderTypes && item.validOrderTypes.length) {
          return item.validOrderTypes.includes(orderType)
        }
        return true
      })
    },
    ...mapGetters([ 'getCustomerRewards', 'shouldUseCustomHeader', 'getActiveRewards', 'getCustomer', 'isLoggedIn', 'getOpenReferral', 'getCustomerRewards', 'doesStoreHaveSetting', 'getRewards', 'getPunchCards', 'getGroup', 'getCurrencyCode', 'getOrderType' ]),
    ...mapMutations(['SET_OPEN_REFERRAL', 'setLoginDialog'])
  },

  methods: {
   getImage(promotion) {
      const url = promotion.imageUrl || promotion.imageURL;
      if (url)
        return `${process.env.VUE_APP_API_IMAGE}${url}`;
      return null;
    },
    ...mapActions(['showSnack', 'fetchShoppingCart']),
    getFullPunchCard(promotion) {
      return this.getPunchCards.find(pc => pc.code === promotion.code) || promotion;
    },
    handleTouch(e) {
      if (e.type === 'touchmove') {
        const touch = e.touches[0];
        if (this._initialX === undefined) {
          this._initialX = touch.clientX;
          this._initialY = touch.clientY;
          return;
        }
        
        const deltaX = Math.abs(touch.clientX - this._initialX);
        const deltaY = Math.abs(touch.clientY - this._initialY);
        
        if (deltaX > deltaY) {
          e.preventDefault();
          e.stopPropagation();
        }
      } else if (e.type === 'touchstart') {
        this._initialX = e.touches[0].clientX;
        this._initialY = e.touches[0].clientY;
      } else if (e.type === 'touchend' || e.type === 'touchcancel') {
        delete this._initialX;
        delete this._initialY;
      }
    },
    handleWheel(e) {
      if (Math.abs(e.deltaX) > Math.abs(e.deltaY)) {
        e.preventDefault();
        e.stopPropagation();
      }
    },
    openDialog() {
      if (this.isLoggedIn) {
        this.$root.$refs.referral.openDialog();
      } else {
        this.showSnack({
          text: 'Please login to get your referral link',
          color: 'secondary'
        })
        this.setLoginDialog(true)
      }
    },
    getRewardErrorMessage(reward) {
      if (!this.isLoggedIn) {
        return this.$vuetify.t('$vuetify.account.rewards.loginRequired');
      }
      
      if (!reward) {
        return this.$vuetify.t('$vuetify.account.rewards.unavailable');
      }

      if (this.isDisabled) {
        return this.$vuetify.t('$vuetify.account.rewards.inPersonRedeemable');
      }

      if (!this.canAfford(reward)) {
        return this.$vuetify.t('$vuetify.account.rewards.insufficientFunds');
      }

      if (this.getActiveRewards && reward && this.getActiveRewards.id != reward.id) {
        return this.$vuetify.t('$vuetify.account.rewards.removeFirst');
      }

      if (!('menuItem' in reward) && this.getActiveRewards && this.getActiveRewards.id == reward.id) {
        return this.$vuetify.t('$vuetify.account.rewards.alreadyInCart', [reward.rewardName]);
      }

      return '';
    },
    getExpirationText(promotion) {
      if (promotion.validTo) {
        const expirationDate = new Date(promotion.validTo);
        const year = expirationDate.getFullYear();
        const month = String(expirationDate.getMonth() + 1).padStart(2, '0');
        const day = String(expirationDate.getDate()).padStart(2, '0');
        return this.$vuetify.t('$vuetify.account.rewards.offerExpires', `${year}-${month}-${day}`);
      }
      return this.$vuetify.t('$vuetify.account.rewards.noExpiration');
    },
    getDiscountText(discountRule) {
      if (discountRule.percent) {
        const text = this.$vuetify.t('$vuetify.account.rewards.discountPercentOff', Math.round(discountRule.percent * 100));
        // Only percentage discounts can be capped; fixed amounts are already their own ceiling.
        const cap = formatDiscountCap(discountRule.maxDiscountAmount, this.getCurrencyCode);
        return cap ? this.$vuetify.t('$vuetify.account.rewards.discountUpTo', text, cap) : text;
      } else if (discountRule.amount) {
        const symbol = getCurrencySymbol(this.getCurrencyCode);
        return this.$vuetify.t('$vuetify.account.rewards.discountAmountOff', symbol, discountRule.amount);
      }
      return '';
    },
    hasTargets(promotion) {
      const itemRelationList = get(promotion, 'menuItem.itemRelationList', []);
      const hasTargets = itemRelationList.some(relation => 
        get(relation, 'targets', []).length > 0
      );
      return hasTargets;
    },
    handleRedeemable(reward) {
      if (this.isLoggedIn) {
        this.$root.$refs.redeemables.openConfig(reward)
      } else {
        this.showSnack({
          text: 'Please login to see your rewards',
          color: 'secondary'
        })
        if (this.$vuetify.breakpoint.smAndDown)
          this.$bus.$emit('toggleCart', true)
        else
          this.setLoginDialog(true)
      }
    },
    handlePunchCard(punchCard) {
        if (this.isLoggedIn) {
          const matched = this.getPunchCards.find(p => p.id == punchCard.id)
          let errorText = ''
          const earned = matched.earned || 0
          const neededPoints = matched.redeemCount != null ? matched.redeemCount - earned : null

          errorText = neededPoints == null
            ? this.$vuetify.t('$vuetify.cart.storeUnavailable')
            : this.$vuetify.t('$vuetify.account.rewards.missingPoints', [neededPoints])
          this.openPunchCardConfig(punchCard)
        } else {
          this.showSnack({
            text: 'Please login to see your rewards',
            color: 'secondary'
          })

          // On mobile, showing the cart makes both the login and rewards cards visible
          if (this.$vuetify.breakpoint.smAndDown)
            this.$bus.$emit('toggleCart', true)
          else
            this.setLoginDialog(true)
        }
      },
      
      openPunchCardConfig(punchCard, retryCount = 0) {
        const maxRetries = 10; 
        if (this.$root.$refs.punchCard && this.$root.$refs.punchCard.openConfig) {
          this.$root.$refs.punchCard.openConfig(punchCard)
          return
        }
        if (retryCount < maxRetries) {
          setTimeout(() => {
            this.openPunchCardConfig(punchCard, retryCount + 1)
          }, 50)
        } else {
          if (this.$store && this.$store._actions && this.$store._actions.setCouponItemDialog) {
            this.$store.dispatch('setCouponItemDialog', punchCard)
          } else {
            this.showSnack({
              text: 'Unable to open punch card. Please refresh the page and try again.',
              color: 'error'
            })
          }
        }
      },
    isRewardValid(reward) {
      if (!this.isLoggedIn) {
        return true
      }
      if (!reward) {
        return false
      }
      if (this.isDisabled) {
        return false
      }

      if (!this.canAfford(reward)) {
        return false
      }

      if (this.getActiveRewards && reward && this.getActiveRewards.id != reward.id) {
        return false
      }
      return true
    },
      canAfford(rewardOption) {
        let previousRewardsSum
        if (this.getExistingOrder && this.getExistingOrder.length) {
          previousRewardsSum = this.getExistingOrder.reduce((accumulator, order) => {
            if (order.redemptionItems.length)
              return (accumulator || 0) + order.redemptionItems.reduce((subSum, reward) => subSum + reward.redeemPoints, 0)
            return accumulator
          }, 0)
        } else {
          previousRewardsSum = 0
        }

      return get(this.getCustomerRewards, 'points', 0) >= rewardOption.redeemPoints + previousRewardsSum
    },
    isCoupon(promotion) {
      return promotion && 'code' in promotion;
    },
    isFullyEligible(promotion) {
      if (!(promotion && 'eligibilityResult' in promotion)) return false;
      return !!promotion.eligibilityResult.isEligible;
    },
    
    shouldShowAsPromoCard(promotion) {
      if (promotion._isCoupon) return true;
      return !('rewardNameString' in promotion ||
               'unitString' in promotion ||
               'unitPluralString' in promotion ||
               'referralNameString' in promotion ||
               'redeemPoints' in promotion);
    },
    
    isEligible(coupon) {
      if (!(coupon && 'eligibilityResult' in coupon)) return false;
      // DEV-11340: Purchase Coupons is deprecated -- never offer a coupon that's for sale.
      if (!!coupon.charges && !coupon.uuid) return false;
      return !!(coupon.eligibilityResult.isEligible ||
             coupon.eligibilityResult.shouldShowIfNotEligible);
    },
    clearCoupon() {
      this.fetchShoppingCart()
    }
  }
}
</script>

<style>
  /* .VueCarousel-wrapper {
    overflow: visible !important;
  } */
  #CouponCardContainer .RewardsCard {
    padding: 5px 10px;
  }
  @media only screen and (max-width: 920px) {
    .VueCarousel-navigation-next {
      right: -18px !important;
      /* margin-right: 10px !important; */
      transform: translateY(-50%) !important;
    }

    .VueCarousel-navigation-prev {
      left: -18px !important;
      /* margin-left: 10px !important; */
      transform: translateY(-50%) !important;
    }
  }
</style>
<style scoped>
.promotion-container {
  touch-action: pan-y;
}

.carousel-container {
  touch-action: pan-x; 
  width: 100%;
  padding-bottom: 10px;
}

.no-page-scroll {
  isolation: isolate;
}
.menuContainer {
  margin-left: 50px;
}
.promoContainer {
  text-align: start;
  margin-left: 18px;
  margin-right: 18px;
  padding-top: 10px;
}
.fieldTitle {
  font-size: 1.4rem;
  font-weight: bold;
  margin-bottom: 15px;
}
.VueCarousel-slide {
  display: flex;
  align-items: stretch;
}
.redeem-points {
  color: var(--v-primary-base);
}

.redeem-points-normal {
  color: var(--v-primary-base);
  font-weight: normal;
  font-size: 11px;
}

.redemption-title {
  color: var(--v-primary-base) !important;
}

.discount-rule {
  color: grey;
  font-size: 11px;
  font-weight: 600;
  margin-top: 2px;
}

.valid-items-rule {
  color: grey;
  font-size: 11px;
  font-weight: 600;
  margin-top: 2px;
}

.discount-text {
  color: #9B9C9F;
  font-size: 10px;
  font-weight: 600;
}

.valid-items-text {
  color: #9B9C9F;
  font-size: 10px;
  font-weight: 600;
}

.expiration-text {
  font-weight: normal;
  font-size: 11px !important;
  margin-top: 0px !important;
}

.rewards-card-content {
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: space-between;
}

.subheader-container {
  margin-top: auto;
}

@media only screen and (min-width: 920px) {
  .rewards-slide {
    width: auto
  }

  .rewards-slide > div {
    width: auto
  }
}
@media only screen and (max-width: 920px) {
  .fieldTitle {
    font-size: calc(var(--text-size-2) * 0.85) !important;
  }
  .menuContainer {
    margin-left: 20px;
  }
  .rewards-carousel {
    max-width: 100vw !important;
    padding: 0 12px;
  }
  .VueCarousel-wrapper {
    padding: 0;
  }

}
.VueCarousel {
  width: 100%;
  max-width: 90vw !important;
  height: 100%;
}
.hover-animation-container {
  padding: 5px 10px;
}
.hover-animation-container .CardContainer {
  border: none !important;
}
.VueCarousel-wrapper {
  justify-content: flex-start !important;
}

.VueCarousel-inner {
  justify-content: flex-start !important;
  margin: 0 !important;
}

.rewards-slide {
  justify-content: flex-start !important;
  margin-right: 0 !important;
  min-height: 120px !important;
}
.promotion-rewards-card.disabled {
  opacity: 0.7;
  pointer-events: none;
  position: relative;
}

.promotion-rewards-card.disabled::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.1);
  z-index: 1;
}
@media (min-width: 960px) {
  .custom-header-carousel {
    width: 91% !important;
  }
}
</style>
